import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthRequest, AuthResponse } from '../models/auth-request.model';
import { Observable } from 'rxjs';
import {
  RefreshTokenRequest,
  RefreshTokenResponse,
} from '../models/refresh-token.model';
import {StringMessage} from "../../shared/errors/models/string-message.model";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private url = environment.webApi + '/api/auth';
	private currentPassword: string | null = null;

  constructor(private http: HttpClient) {}

	setPassword(password: string): void {
		this.currentPassword = btoa(password);
	}

	getPassword(): string | null {
		return this.currentPassword ? atob(this.currentPassword) : null;
	}

	clearPassword(): void {
		this.currentPassword = null;
	}

  signIn(authRequest: AuthRequest): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(this.url + '/sign-in', authRequest);
  }

  refreshToken(refreshTokenRequest: RefreshTokenRequest): Observable<RefreshTokenResponse> {
    return this.http.post<RefreshTokenResponse>(this.url + '/refresh-token', refreshTokenRequest);
  }

  newPtm(): Observable<StringMessage> {
    return this.http.get<StringMessage>(this.url + '/new-ptm');
  }
}
